export const highAndHas = (fieldName) =>
  `${fieldName} can only contain lowercase letters, numbers, underscores and no spaces`;
